import { Highlight } from 'react-instantsearch-dom'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import IdeaIcon from '../assets/icon-content-type-idea'
import LinkIcon from './Link'
import tracker from '../../components/tracker/publish'

const eventTracker = (item, topicType, idx) => {
  tracker.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: item.title,
    topic_url: item.topic_url,
    topic_position: idx + 1, // to start index from 1 instead of 0, added +1
    topic_topic_type: topicType,
    click_source: 'Topic creation suggestion'
  })
}

const getTopicType = (hit) => {
  if (hit.is_article) {
    return 'article'
  } else if (hit.is_ideation) {
    return 'ideation'
  } else if (hit.has_answer) {
    return 'answer'
  } else if (hit.content_type === 'question') {
    return 'question'
  }
  return 'conversation'
}

const SuggestedTopicsList = ({ hits }) => {
  const topicIcons = {
    'question': <QuestionIcon />,
    'article': <ArticleIcon />,
    'answer': <AnswerIcon />,
    'conversation': <DiscussionIcon />,
    'ideation': <IdeaIcon />
  }

  return (
    <ul className='topic-create_suggestions-list'>
      {
        hits.map((hit, idx) => {
          let topicType = getTopicType(hit)

          return <li>
            <a onClick={() => eventTracker(hit, topicType, idx)} className='topic-create_suggestions-item' href={hit.topic_url} target='_blank'>
              <span className='topic-create_suggestions_type-icon'>{ topicIcons[topicType] }</span>
              <span className='topic-create_suggestions-item-text'>
                <Highlight attribute='title' hit={hit} tagName='strong' />
              </span>
              <span className='topic-create_suggestions_link-icon'><LinkIcon /></span>
            </a>
          </li>
        })
      }
    </ul>
  )
}

export default SuggestedTopicsList
